export default "__VITE_ASSET__eIaHG_XV__"